import React from 'react';
import { Box } from '@mui/material';

/**
 * Brand-colored top stripe — the smallest possible visual signature that
 * makes every authenticated page feel like FuseSoul rather than generic MUI.
 *
 * Drop once at the top of the protected app shell. Sits above the AppBar.
 */
const BrandStripe = () => (
  <Box
    aria-hidden
    sx={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      height: '3px',
      background: 'linear-gradient(90deg, var(--primary-color, #22489E) 0%, #4666B5 50%, #14B8A6 100%)',
      zIndex: 1400, // above AppBar (1350) so it's always visible
      pointerEvents: 'none',
    }}
  />
);

export default BrandStripe;
